const QUERY_SOURCE_EVENTS = new Set([
    'submit query',
    'SUCCESSFUL response',
    'FAILED response',
]);
const SOURCELESS_EVENTS = new Set([
    'computer artifact open attempted',
    'query first server response',
    'query first llm token',
    'thread execution stopped',
]);
export function resolveAskInstrumentationSource(eventName, defaultSource, querySource) {
    if (QUERY_SOURCE_EVENTS.has(eventName)) {
        return querySource;
    }
    if (SOURCELESS_EVENTS.has(eventName)) {
        return undefined;
    }
    return defaultSource;
}
//# sourceMappingURL=AskInstrumentationTransportSupport.js.map